import { Text } from '@capsicum/common-web';
import { getFormattedDateTime } from '@capsicum/features/wallet/shared';

export const DateField = ({ value }: { value: string }) => {
	return <Text variant="text1">{getFormattedDateTime(value, false)}</Text>;
};
